export default __webpack_public_path__ + "static/media/Logo.c20493cc.png";